const TODO_FOCUS_PARAM = "todoFocus";
const TODO_FOCUS_REQUEST_PARAM = "todoFocusRequest";
const OVERALL_SCORE_TARGET = "overall-score";

/** Adds the durable part of the To Do rail's Overall Score focus intent. */
export function withTodoOverallScoreFocus(path: string): string {
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}${TODO_FOCUS_PARAM}=${OVERALL_SCORE_TARGET}`;
}

/**
 * Gives each click its own request identity, including when the destination is
 * already the current page and the durable focus intent is unchanged.
 */
export function refreshTodoFocusRequest(
  href: string,
  requestId: string = Date.now().toString(36),
): string {
  const routerRootPrefix = href.startsWith("~/") ? "~" : "";
  const url = new URL(
    routerRootPrefix === "" ? href : href.slice(1),
    "https://todo.local",
  );

  if (url.searchParams.get(TODO_FOCUS_PARAM) !== OVERALL_SCORE_TARGET) {
    return href;
  }

  url.searchParams.set(TODO_FOCUS_REQUEST_PARAM, requestId);
  return `${routerRootPrefix}${url.pathname}${url.search}${url.hash}`;
}

/** A stable key for the header's focus effect, or null for ordinary visits. */
export function parseTodoOverallScoreFocus(search: string): string | null {
  const params = new URLSearchParams(search);

  if (params.get(TODO_FOCUS_PARAM) !== OVERALL_SCORE_TARGET) {
    return null;
  }

  return params.get(TODO_FOCUS_REQUEST_PARAM) ?? "initial";
}
